import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const documentadd: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={iconColor}
        d="M12.5,4.4963 L12.5,9.4963 L17.5,9.4963 M9,12.5002 L15,12.5002 M8.9976,14.4997 L14.9996,14.4997 M9,16.4997 L15,16.4997 M17.5,16.9997 L17.5,21.9997 M19.999,19.4997 L14.999,19.4997 M13,19.4997 L6.5,19.4997 L6.5,4.4997 L12.5,4.4997 L17.5,9.4997 L17.5,14.9997"
      />
    </svg>
  );
};
